import styled from 'styled-components';
import { Link } from '@material-ui/core';
import THEME from '../../../theme';

const StyledLink = styled(Link)`
  color: ${THEME.baseColor.neutral.main};
  text-decoration-color: ${THEME.baseColor.neutral.main};
  cursor: pointer;
`;

export default StyledLink;
